<template>
  <div>
    <div class="news_bulletin_wrapper clearfix common_width hidden-xs-only">
      <div class="nbw_l fl">
        <el-carousel class="carousel_wrapper" :interval="2000" indicator-position="none" arrow="always" height="360px"
          @change="carouselActive">
          <el-carousel-item v-for="(item, idx) in imgList" :key="idx" :name="item.title" :label="item.title">
            <img :src="item.imageUrl" alt="" style="cursor: pointer" @click="jumpDetail(item)" />
            <div class="mark">{{ item.title }}</div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="nbw_r fl">
        <div class="top_bar clearfix">
          <div class="item" @click="selectTabBar(idx)" v-for="(item, idx) in topBarList"
            :class="{ selectitem: idx == initIndex }" :key="idx">
            {{ item.text }}
          </div>
        </div>
        <div class="content_wrapper">
          <div v-for="(item, idx) in contentList" v-show="idx == initIndex" class="content_item" :key="idx">
            <div v-for="(innerItem, innerIdx) in item.contentObj.newsList" class="item clearfix" :key="innerIdx" @click="jumpDetail(innerItem)">
              <span class="circular fl">&#xe62f;</span>
              <p :class="['text', 'fl',{activeText: innerIdx == carouselIndex}]">{{ innerItem.title }}</p>
              <p v-if="innerItem.createTime" :class="['time', 'fl',{activeText: innerIdx == carouselIndex}]">
                {{ innerItem.createTime.slice(0, 10) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="news_bulletin_pe_wrapper hidden-sm-and-up">
      <div class="tab_select">
        <div class="item" @click="selectTabBar(idx)" v-for="(item, idx) in topBarList"
          :class="{ selectitem: idx == initIndex }" :key="idx">
          {{ item.text }}
        </div>
      </div>
      <div class="content">
        <el-carousel class="carousel_wrapper" :interval="2000" indicator-position="none" arrow="always" height="175px">
          <el-carousel-item v-for="(item, idx) in imgList" :key="idx">
            <img :src="item.imageUrl" alt="" style="cursor: pointer" @click="jumpDetail(item)" />
            <div class="mark">{{ item.title }}</div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="detail" v-show="idx == initIndex" v-for="(item, idx) in contentList" :key="idx">
        <div v-for="(innerItem, innerIdx) in item.contentObj.newsList" class="item clearfix" :key="innerIdx"
          @click="jumpDetail(innerItem)">
          <span class="circular fl">&#xe62f;</span>
          <p class="text fl">{{ innerItem.title }}</p>
          <p v-if="innerItem.createTime" class="time fr">
            {{ innerItem.createTime.slice(0, 10) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CommonTitle from "@/components/title";
  import PhoneTitle from "@/components/phonetitle";
  import {
    groupLtIe,
    industryLtIe,
    projectLtIe
  } from "../../../api/Home/home";
  export default {
    mounted() {
      this.initPage();
    },
    components: {
      CommonTitle,
      PhoneTitle,
    },
    computed: {
      timeFormat() {
        return (time) => {
          return time.slice(0, 10);
        };
      },
    },
    methods: {
      // 初始化
      initPage() {
        this.getGroupLtRt();
        // this.getProjectLtRt();
        // this.getIndustryLtRt();
      },
      selectTabBar(index) {
        this.initIndex = index;
        switch (index) {
          case 0:
            this.getGroupLtRt();
            break;
          case 1:
            this.getProjectLtRt();
            break;
          case 2:
            this.getIndustryLtRt();
            break;
        }
      },
      // 列表跳详情
      jumpDetail(item) {
        this.$router.push({
          path: "detail",
          query: {
            detailObj: item,
          },
        });
      },
      // 获取公司要闻列表
      getGroupLtRt() {
        groupLtIe().then((res) => {
          if (res.msg == "暂无数据") {
            this.contentList[0].contentObj.newsList = [];
            this.commonNewsList = [];
            this.newsTextPeList = [];
            this.imgList = [];
          } else {
            this.contentList[0].contentObj.newsList = res.data;
            this.commonNewsList = res.data;
            this.newsTextPeList = res.data;
            this.imgList = res.data;
          }
        });
      },
      // 获取项目动态列表
      getProjectLtRt() {
        projectLtIe().then((res) => {
          if (res.msg == "暂无数据") {
            this.contentList[1].contentObj.newsList = [];
            this.commonNewsList = [];
            this.dynamicsTextPeList = [];
            this.imgList = [];
            this.$forceUpdate()
          } else {
            this.contentList[1].contentObj.newsList = res.data;
            this.commonNewsList = res.data;
            this.dynamicsTextPeList = res.data;
            this.imgList = res.data;
            this.$forceUpdate()
          }
        });
      },
      // 获取通知公告列表
      getIndustryLtRt() {
        industryLtIe().then((res) => {
          if (res.msg == "暂无数据") {
            this.contentList[2].contentObj.newsList = [];
            this.commonNewsList = [];
            this.noticeTextPeList = [];
            this.imgList = [];
          } else {
            this.contentList[2].contentObj.newsList = res.data;
            this.commonNewsList = res.data;
            this.noticeTextPeList = res.data;
            this.imgList = res.data;
          }
        });
      },
      carouselActive(newIndex, oldIndex) {
        this.carouselIndex = newIndex;
      },
    },
    data() {
      return {
        commonNewsList: [],
        newsText: {
          title: "公司要闻",
          introduction: "推荐公司相关要闻",
        },
        newsTextPeList: [], // phone 公司要闻
        noticeText: {
          title: "通知公告",
          introduction: "推荐行业通知公告",
        },
        noticeTextPeList: [], // phone 通知公告
        dynamicsText: {
          title: "项目动态",
          introduction: "推荐行业项目动态",
        },
        dynamicsTextPeList: [], // phone 项目动态
        imgList: [],
        carouselIndex : 0,
        topBarList: [{
            text: "公司要闻",
          },
          {
            text: "项目动态",
          },
          {
            text: "通知公告",
          }
        ],
        contentList: [{
            contentObj: {
              newsList: [],
            },
          },
          {
            contentObj: {
              newsList: [],
            },
          },
          {
            contentObj: {
              newsList: [],
            },
          },
        ],
        initIndex: 0,
      };
    },
  };

</script>

<style lang="scss" scoped>
  @import "@/assets/styles/common.scss";
  @import "../../../assets/styles/mixin.scss";

  // move
  // tab
  .news_bulletin_pe_wrapper {
    width: 100%;
    padding: 0 px2rem(10);
    box-sizing: border-box;
    margin-top: px2rem(20);

    .tab_select {
      display: flex;
      justify-content: flex-start;
      height: px2rem(30);
      background-color: rgb(242, 246, 248);

      .item {
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
        color: #333;
      }

      .selectitem {
        background-color: rgb(39, 96, 183);
        color: #fff;
      }
    }
    .mark {
          box-sizing: border-box;
          position: absolute;
          width: 100%;
          height: 40px;
          padding-left: 15px;
          line-height: 40px;
          z-index: 9999;
          bottom: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.4);
          // opacity: 0.7;
          color: #fff;
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
    .content {
      margin-top: px2rem(10);

      .carousel_wrapper {
        img {
          width: 100%;
          height: 175px;
        }
      }
    }

    .detail {
      box-sizing: border-box;
      width: 100%;
      padding: px2rem(20) px2rem(10) px2rem(20) px2rem(5);
      border: 1px solid #ccc;
      border-top: none;

      .circular {
        font-family: "iconfont";
        font-size: px2rem(28);
      }

      .item {
        line-height: px2rem(30);
        color: #000;
        font-size: px2rem(14);

        .text {
          width: 65%;
          overflow: hidden;
          display: inline-block;
          cursor: pointer;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }

        .time {
          color: #ccc;
        }
      }
    }
  }

  // 旧
  .news_bulletin_phone_wrapper {
    width: 100%;
    padding: 0 px2rem(20);
    box-sizing: border-box;
    margin-top: px2rem(20);

    .top {
      width: 100%;
      height: px2rem(39);
    }

    .bottom {
      width: 100%;
      box-sizing: border-box;
      margin-top: px2rem(20);

      .bottom_box {
        padding: px2rem(20);
        padding-right: px2rem(30);
        box-shadow: rgba(0, 0, 0, 0.247) 0px 0px px2rem(10); //将颜色提到前面，且将h-shadow,v-shadow设为0px,实现四周阴影
        border-bottom: px2rem(1) solid #ccc;

        img {
          width: 100%;
          height: px2rem(200);
          margin-bottom: px2rem(20);
        }

        .item {
          padding-bottom: px2rem(10);
          padding-left: px2rem(5);
          font-size: px2rem(14);
          border-bottom: 1px solid #ccc;
          margin-bottom: px2rem(20);

          span {
            float: left;

            &:nth-child(2) {
              width: 65%;
            }
          }

          .time {
            float: right;
            color: #333;
            font-size: px2rem(12);
          }
        }
      }
    }
  }

  // pc
  .news_bulletin_wrapper {
    margin-top: 37px;
    margin-bottom: 43px;
    height: 360px;

    .nbw_l {
      width: 580px;
      height: 100%;
      margin-right: 20px;

      img {
        width: 580px;
        height: 360px;
      }

      .carousel_wrapper {
        position: relative;

        .mark {
          box-sizing: border-box;
          position: absolute;
          width: 100%;
          height: 40px;
          padding-left: 15px;
          line-height: 40px;
          z-index: 9999;
          bottom: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.4);
          // opacity: 0.7;
          color: #fff;
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    .nbw_r {
      width: 547px;
      height: 100%;

      .top_bar {
        width: 100%;
        background-color: rgb(242, 246, 248);

        .item {
          float: left;
          width: 182px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          color: #333;
          font-size: 14px;
          cursor: pointer;
        }

        .selectitem {
          background-color: rgb(39, 96, 183);
          color: #fff;
        }
      }

      .content_wrapper {
        width: 100%;
        height: 320px;

        .item {
          height: 41px;
          line-height: 41px;
          cursor: pointer;

          span {
            display: inline-block;
            line-height: 41px;
          }

          .circular {
            font-family: "iconfont";
            font-size: 32px;
          }

          .text {
            width: 390px;
            font-size: 16px;
            overflow: hidden;
            display: inline-block;
            cursor: pointer;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            transition: 0.2s;
          }

          .time {
            color: #ccc;
            font-size: 14px;
            transition: 0.2s;
          }

          .activeText {
            color: #2760b7;
            font-weight: 600;
          }

          &:hover {
            color: rgb(22, 120, 191);

            p {
              color: rgb(22, 120, 191);
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/Home/components/Newsbulletin.vue